<p-tabView *ngIf="fonteDados">

  <p-tabPanel header="Geral">
    <div class="p-grid">
    <div class="p-col-12 p-lg-12">
      <p-card>
        <p-table [value]="tipos"
          responsive="true"
          sortMode="multiple"
          responsiveLayout="scroll"
          styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th style="text-align: center;">Tipo de entidade</th>
              <th style="text-align: center; width: 300px">Situação</th>
              <th style="text-align: center;">Ação</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-tipo>
            <tr>
              <td class="text-left">{{tipo.nome}}</td>
              <td>
                <div class="p-grid p-fluid">
                  <div class="p-col-4" style="text-align: right;">
                    <span *ngIf="tipo.situacao === 'SINCRONIZANDO'" class="pi pi-fw pi-spin pi-spinner"></span>
                    <span *ngIf="tipo.situacao === 'SINCRONIZADO'" class="pi pi-check p-text-bold" style="color: green"></span>
                    <span *ngIf="tipo.situacao === 'FALHA_SINCRONIZACAO'" class="pi pi-times" style="color: red"></span>
                  </div>
                  <div class="p-col-8" style="text-align: left;">
                    <span *ngIf="tipo.situacao === 'INICIAL'">Inicial               </span>
                    <span *ngIf="tipo.situacao === 'SINCRONIZANDO'">Sincronizando...</span>
                    <span *ngIf="tipo.situacao === 'SINCRONIZADO'">Sincronizado     </span>
                    <span *ngIf="tipo.situacao === 'FALHA_SINCRONIZACAO'">Falha na sincronização</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="p-grid p-fluid">
                  <div class="p-col-12">
                    <button pButton label="Sincronizar" title="Sincronizar" (click)="sincronizarTipo(tipo)"></button>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="p-grid">
              <div class="p-col-12" style="text-align: center">
                  <button pButton class="p-col-12" label="Sincronizar tudo" (click)="sincronizarTudo()"></button>
              </div>
            </div>
          </ng-template>
      </p-table>
      </p-card>
    </div>
  </div>
  </p-tabPanel>

  <p-tabPanel header="Competência">
    <div class="p-fluid">
      <app-competencia-local-lista #competenciaLocalLista [fonteDados]="fonteDados">
      </app-competencia-local-lista>
    </div>
  </p-tabPanel>

  <p-tabPanel header="Tipo Parte">
    <div class="p-fluid">
      <app-tipo-parte-local-lista #tipoParteLocalLista [fonteDados]="fonteDados">
      </app-tipo-parte-local-lista>
    </div>
  </p-tabPanel>

  <p-tabPanel header="Tipo Processo Documento">
    <div class="p-fluid">
      <app-tipo-proc-doc-loc-lista #tipoProcessoDocumentoLocalLista [fonteDados]="fonteDados">
      </app-tipo-proc-doc-loc-lista>
    </div>
  </p-tabPanel>

  <p-tabPanel header="Orgão Julgador">
    <div class="p-fluid">
      <app-orgao-julgador-local-lista #orgaoJulgadorLocalLista [fonteDados]="fonteDados">
      </app-orgao-julgador-local-lista>
    </div>
  </p-tabPanel>

  <p-tabPanel header="Orgão Julgador Colegiado">
    <div class="p-fluid">
      <app-orgao-julgador-colegiado-local-lista #orgaoJulgadorColegiadoLocalLista [fonteDados]="fonteDados">
      </app-orgao-julgador-colegiado-local-lista>
    </div>
  </p-tabPanel>
  <p-tabPanel header="Jurisdição Local">
    <div class="p-fluid">
      <app-jurisdicao-local-lista #jurisdicaoLocalLista [fonteDados]="fonteDados">
      </app-jurisdicao-local-lista>
    </div>
  </p-tabPanel>
</p-tabView>
